import { StyleSheet, View } from "react-native";
import React, { useEffect, useState } from "react";
import Image from "@components/common/Image";
import Text from "@components/CustomText";
import LinearGradient from "react-native-linear-gradient";
import { TouchableOpacity } from "react-native-gesture-handler";
import { colors } from "@utils/styles";
import ArrowRightMedium from "@assets/svg/ArrowRightMedium";
import VideoModal from "@components/VideoPlayer/VideoModal";
import { useSelector } from "react-redux";
import analytics from "@services/analytics";
import { EARLY_JOURNEY } from "@constants/analyticsEventsCT";

const FullPageVideoModal = ({ navigation }) => {
  const [videoEnd, setVideoEnd] = useState();
  const [showVideo, setShowVideo] = useState(false);
  const earlyJourney = useSelector(
    (state) => state.auth.user.earlyJourney?.videoScreen,
  );

  useEffect(() => {
    analytics.trackEvent(EARLY_JOURNEY.VIDEO_STARTED);
    setTimeout(() => {
      setShowVideo(true);
    }, 200);
  }, []);

  const handleOnPressJudein = () => {
    analytics.trackEvent(EARLY_JOURNEY.VIDEO_AAGE_BADHE);
    navigation.replace("OnBoardingQuestionaire");
  };

  const handleOnVideoEnd = () => {
    analytics.trackEvent(EARLY_JOURNEY.VIDEO_COMPLETED);
    setVideoEnd(true);
  };

  const pausedEventTrack = () => {
    analytics.trackEvent(EARLY_JOURNEY.VIDEO_PAUSED);
  };

  const resumedEventTrack = () => {
    analytics.trackEvent(EARLY_JOURNEY.VIDEO_RESUMED);
  };

  const handleWatchAgain = () => {
    setVideoEnd(false);
    analytics.trackEvent(EARLY_JOURNEY.VIDEO_DOBARA_DEKHE);
  };

  if (!earlyJourney) {
    return null;
  }

  return (
    <View style={styles.container}>
      {showVideo && !videoEnd && (
        <VideoModal
          onEnd={handleOnVideoEnd}
          setShow={() => navigation.goBack()}
          show={true}
          hideCloseIcon={true}
          video_link={earlyJourney.videoUrl}
          pausedEventTrack={pausedEventTrack}
          resumedEventTrack={resumedEventTrack}
        />
      )}
      {videoEnd && (
        <>
          <Image
            style={{ ...StyleSheet.absoluteFill }}
            source={{
              uri: earlyJourney.backgroundImageUrl,
            }}
          />
          <LinearGradient
            style={styles.bgGradient1}
            colors={["rgba(0, 0, 0, 0.2)", "rgba(0, 0, 0, 0.7)"]}
          >
            <View style={styles.content}>
              <Image
                style={styles.logoImage}
                source={{
                  uri: earlyJourney.logoUrl,
                }}
              />
              <Text
                newfont
                variant="title_18_semi"
                style={[styles.colorWhite, styles.welcomeText]}
              >
                Welcome to
              </Text>
              <Text newfont variant="heading_24" style={styles.colorWhite}>
                CITYMALL PARTNER
              </Text>
              <Text
                newfont
                variant="body_text_1"
                style={[styles.colorWhite, styles.descriptionText]}
              >
                {earlyJourney.text}
              </Text>
            </View>
            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={styles.replayButton}
                onPress={handleWatchAgain}
              >
                <Text
                  newfont
                  variant="title_18"
                  style={[styles.colorWhite, { marginRight: 15 }]}
                >
                  Dobara video dekhein
                </Text>
                <View
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Image
                    resizeMode="contain"
                    source={{
                      uri: earlyJourney.imageReplayCover,
                    }}
                    style={styles.replayImageCover}
                  />
                  <Image
                    resizeMode="contain"
                    source={{
                      uri: "https://d1u5bdo1v30woh.cloudfront.net/cmimgopt-2a0fd942-bef2-4c08-bd6f-657a0cfae552.jpeg",
                    }}
                    style={styles.replayImage}
                  />
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.ctaButton}
                onPress={handleOnPressJudein}
              >
                <Text
                  newfont
                  variant="title_18"
                  style={[styles.colorWhite, { marginRight: 15 }]}
                >
                  Chaliye! aage badhte hein
                </Text>
                <ArrowRightMedium />
              </TouchableOpacity>
            </View>
          </LinearGradient>
        </>
      )}
    </View>
  );
};

export default FullPageVideoModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    alignItems: "center",
  },
  logoImage: { width: 88, height: 88 },
  bgGradient1: {
    flex: 1,
    justifyContent: "center",
    padding: 15,
  },
  colorWhite: {
    color: "#fff",
  },
  welcomeText: {
    marginTop: 12,
  },
  descriptionText: {
    textAlign: "center",
    marginBottom: 10,
  },
  replayButton: {
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "rgba(255, 255, 255, 0.4)",
    borderRadius: 8,
    paddingHorizontal: 45,
    paddingVertical: 12,
    justifyContent: "center",
    flexDirection: "row",
  },
  ctaButton: {
    backgroundColor: colors.raddishPink1,
    borderRadius: 8,
    paddingHorizontal: 45,
    paddingVertical: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 15,
  },
  replayImage: {
    height: 32,
    width: 32,
    // marginLeft: 15,
    borderWidth: 1,
    borderColor: "#fff",
    borderRadius: 8,
  },
  replayImageCover: {
    position: "absolute",
    zIndex: 1,
    height: 25,
    width: 25,
  },
  buttonContainer: {
    width: "100%",
    marginHorizontal: 15,
    marginBottom: 15,
    position: "absolute",
    bottom: 0,
  },
});
